import type { FC } from 'react';
import React from 'react';

import { Box, Collapse, Typography, useTheme } from '@mui/material';

type ErrorMessageProps = {
  isShow?: boolean;
  message?: string;
  testID?: string;
};

export const InputError: FC<ErrorMessageProps> = ({ isShow, message, testID }) => {
  const theme = useTheme();
  return (
    <Collapse in={isShow}>
      <Box
        sx={{
          marginTop: '4px',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'start',
        }}
      >
        <Typography
          variant="t12r"
          id={testID}
          sx={{
            color: theme.palette.case.red.r600,
            wordWrap: 'break-word',
          }}
        >
          {message}
        </Typography>
      </Box>
    </Collapse>
  );
};
